










import {Component, Prop, Vue} from "vue-property-decorator";
import {namespace} from "vuex-class";

const Auth = namespace("Auth");

@Component
export default class PlantEditButton extends Vue {
    @Prop() private id!: string;

    get plantId() {
        return this.$route.params.id
    }

    @Auth.State("user")
    private currentUser!: any;

    get isLoggedIn() {
        return !!this.currentUser;
    }

    edit() {
        this.$router.push({name: "plant_edit", params: {id: this.id, lang: this.$route.params.lang}})
    }
}
